// extracted by mini-css-extract-plugin
export default {"workspace":"styles_workspace__5Ucs6","body":"styles_body__3FkiQ","sidebar":"styles_sidebar__hwV74","content":"styles_content__SaCyP","profileCard":"styles_profileCard__XMXKq"};